.list {
  width: 44rem;
  max-height: 28rem;
  overflow-y: auto;
  padding: 0.8rem;
  z-index: 1000;
  border-radius: var(--border-radius-medium);
  border: 1px solid var(--color-stroke-default);
  background: var(--color-surface-secondary);
}
